import { HOST_ORIGINS as ALLOWED_ORIGINS, getHostOrigin } from "../../auth/embeddedAuth";

// Tiny message bus for the three panels (and the host app).
// - Same origin: BroadcastChannel.
// - Host app in between: window.postMessage (host relays to its other iframes).
// Messages carry an id so a message that arrives twice (channel + relay) is handled once.
const SOURCE = "eplan-layout";

const referrerOrigin = () => {
  try { return new URL(document.referrer).origin; } catch { return null; }
};

export function createLayoutChannel(projectId, onMessage) {
  const bc = typeof BroadcastChannel !== "undefined"
    ? new BroadcastChannel(`${SOURCE}:${projectId}`)
    : null;
  const seen = new Set();
  const clientId = Math.random().toString(36).slice(2);

  const deliver = (env) => {
    if (!env || env.from === clientId || seen.has(env.id)) return;
    seen.add(env.id);
    if (seen.size > 200) seen.delete(seen.values().next().value);
    onMessage(env.msg);
  };

  if (bc) bc.onmessage = (e) => deliver(e.data);

  const onWindowMessage = (e) => {
    const d = e.data;
    if (d?.source !== SOURCE || String(d.projectId) !== String(projectId)) return;
    const sameOrigin = e.origin === window.location.origin;
    const fromHost = ALLOWED_ORIGINS.includes(e.origin) && e.source === window.parent;
    if (!sameOrigin && !fromHost) return;
    deliver(d.env);
  };
  window.addEventListener("message", onWindowMessage);

  return {
    send(msg) {
      const env = { id: `${clientId}-${Date.now()}-${Math.random()}`, from: clientId, msg };
      seen.add(env.id);
      bc?.postMessage(env);
      if (window.parent !== window) {
        const target = getHostOrigin() ?? referrerOrigin();
        if (target && ALLOWED_ORIGINS.includes(target)) {
          window.parent.postMessage({ source: SOURCE, projectId, env }, target);
        }
      }
    },
    close() {
      bc?.close();
      window.removeEventListener("message", onWindowMessage);
    },
  };
}